/* eslint-disable camelcase */
import type { BasketCheckoutButtonModel } from 'autogen/swagger/all';
import { GoToCheckoutMobile } from 'autogen/translation-keys/trans-website-basket';
import { ButtonWithIcon } from 'components/Button';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useOpenLoginQuickView } from 'components/login/shared/hooks/useLoginInfoQuickView';
import UAEventTracking from 'modules/tracking/UAEventTracking';
import type { ReactNode } from 'react';
import Icon from 'components/Icon';

const StyledButtonWithIcon = styled(ButtonWithIcon)`
    flex: 2;
`;

export default function BasketCheckoutNotAuthenticatedButton({
    model,
    children
}: {
    model: BasketCheckoutButtonModel;
    children: ReactNode;
}) {
    const { isEnabled, loginRequest } = model;
    const { t } = useTranslation();
    const openLoginQuickView = useOpenLoginQuickView({ ...loginRequest, level: 'Hard' });

    const handleLogin = async () => {
        openLoginQuickView();
        UAEventTracking({ eventCategory: 'basket', eventAction: 'openSSOModal', eventLabel: t(GoToCheckoutMobile) });
    };

    return (
        <StyledButtonWithIcon
            disabled={!isEnabled}
            icon={<Icon type="ChevronRight" size={16} />}
            size="lg"
            iconProperties={{ position: 'right' }}
            onClick={handleLogin}
        >
            {children}
        </StyledButtonWithIcon>
    );
}
